export enum THEME {
  LIGHT = 'light',
  DARK = 'dark',
  REBRAND_LIGHT = 'rebrandLight',
  REBRAND_DARK = 'rebrandDark',
}
